export default __webpack_public_path__ + "static/media/tswe320.c8392ad9.png";